import React, {Component} from 'react';
import {Box} from 'reactjs-admin-lte'
import {Modal,Button,ControlLabel,Form,FormGroup,Row,Col,FormControl,ProgressBar} from 'react-bootstrap'
import Select from 'react-select';
import FontAwsome from 'react-fontawesome'
// import { Checkbox, Radio } from 'react-icheck';
import WorkdocStore from '../../stores/WorkdocStore';
import AdminStore from '../../stores/AdminStore'
import './AdminPage.css';

class AdminPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:true,
      data:[],
      roles:[],
      workNo:"",
      invoiceNo:"",
      disk_used:"",
      disk_usep:"",
      showAddUser:false,
      showAddRole:false,
      showDeactive:false,
      showRoleDelete:false,
      showReset:false,
      showSuccess:false,
      showPassNotMatch:false,
      titleSuccess:"",
      titleUser:"",
      checkReset:0,
      inputPass:[],
      inputUser:[],
      inputRole:[]
    }
  }

  componentDidMount() {
    this.loadData()
  }

  loadData() {
    let that = this
  	WorkdocStore.loadManageuser(function(result) {
      that.setState({roles:result.data.roles,data:result.data.users,workNo:result.data.work_no,invoiceNo:result.data.invoice_no,disk_used:result.data.disk_used,disk_usep:result.data.disk_usep})
    })
  }

  renderUserTableRowData() {
    let {data} = this.state
    if (data.length<1) {
      return(<tr><td colSpan={10}>ไม่พบข้อมูล</td></tr>)
    } else {
      let badge = ""
      return(
        data.map((item,index) => { 
          if (item.role==="admin"||item.role==="manager") {
            badge = "badge bg-red"
          } else {
            badge = "badge bg-blue"
          }
          return(
            <tr key={index}>
              <td className="text-center">{index+1}</td>
              <td>{item.userid}</td>
              <td>{item.name}</td>
              <td>{item.retrylogin}</td>
              <td>{item.last_updated}</td>
              <td>{item.usertype}</td>
              <td>
                <span className={badge}>{item.role}</span>
              </td>
              <td>
                <Button 
                  className="btn btn-warning" 
                  onClick={this.onNewUserClick.bind(this,'edit',item)}
                >
                  <FontAwsome name="pencil" />&nbsp;Edit
                </Button>
              </td>
              <td>
                <Button className="btn btn-danger" onClick={this.onDeactiveClick.bind(this)}><FontAwsome name="trash-o" />&nbsp;Deactive</Button>
              </td>
              <td>
                <Button className="btn btn-primary" onClick={this.onResetClick.bind(this)}><FontAwsome name="power-off" />&nbsp;Reset</Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderRoleTableRowData() {
    let {roles} = this.state
    if (roles.length<1) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        roles.map((item,index) => { 
          return(
            <tr key={index} >
              <td className="text-center">{index+1}</td>
              <td>{item.bf_role_id}</td>
              <td>{item.name}</td>
              <td>
                <Button className="btn btn-warning" onClick={this.onRoleEditClick.bind(this,item)}><FontAwsome name="pencil" />&nbsp;Edit</Button>
              </td>
              <td>
                <Button className="btn btn-danger" onClick={this.onRoleDeleteClick.bind(this,item)}><FontAwsome name="trash-o" />&nbsp;Delete</Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderUserTable() {
    return(
      <div className="table-responsive">
        <table className="table table-bordered table-color-blue">
          <thead>
            <tr>
              <th className="text-center" style={{width:'10px'}}>#</th>
              <th>Email</th>
              <th>Name</th>
              <th>Retry</th>
              <th>Last-Login</th>
              <th style={{width:'40px'}}>Type</th>
              <th style={{width:'40px'}}>Role</th>
              <th style={{width:'40px'}}>Edit</th>
              <th style={{width:'40px'}}>Action</th>
              <th style={{width:'40px'}}>Password</th>
            </tr>
          </thead>
          <tbody>
            {this.renderUserTableRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderRoleTable() {
    return(
      <div className="table-responsive">
        <table className="table table-bordered table-color-blue">
          <thead>
            <tr>
              <th className="text-center" style={{width:'10px'}}>#</th>
              <th style={{width:'150px'}}>Role</th>
              <th style={{width:'150px'}}>Name</th>
              <th style={{width:'40px'}}>Edit</th>
              <th style={{width:'40px'}}>Delete ?</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRoleTableRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderOption() {
    return(
      <Form horizontal>
        <FormGroup>
          <Col componentClass={ControlLabel} sm={4}>
            WO(N)
          </Col>
          <Col sm={7}>
            <FormControl 
              placeholder="Nxxxxx" 
              value={this.state.workNo}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col componentClass={ControlLabel} sm={4}>
            IV(PJTS 60/)
          </Col>
          <Col sm={7}>
            <FormControl 
              placeholder="PJTS 59/xxx" 
              value={this.state.invoiceNo}
            />
          </Col>
        </FormGroup>
      </Form>  
    )
  }

  renderActivityLog() {
    let {disk_used,disk_usep} = this.state
    let pro = disk_usep.replace("%", "")
    pro = (pro*1)
    return(
      <div className="table-responsive">
        <table className="table table-condensed">
          <thead>
            <tr>
              <th className="text-center" style={{width:'10px'}}>#</th>
              <th>User</th>
              <th>Action</th>
              <th style={{width:'40px'}}>Size</th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <td className="text-center">1</td>
              <td>Disk Usage - {disk_used}</td>
              <td>
                <ProgressBar striped bsStyle="danger" now={pro} />
              </td>
              <td>
                <span className="badge bg-red">{disk_usep}</span>
              </td>
            </tr>
            <tr key={1}>
              <td className="text-center">2</td>
              <td>CPU Usage</td>
              <td><ProgressBar striped now={70} /></td>
              <td><span className="badge bg-yellow">70%</span></td>
            </tr>
            <tr key={2}>
              <td className="text-center">3</td>
              <td>AccessLog</td>
              <td><ProgressBar striped now={30} /></td>
              <td><span className="badge bg-blue">30%</span></td>
            </tr>
            <tr key={3}>
              <td className="text-center">4</td>
              <td>Fix and squish bugs</td>
              <td><ProgressBar striped bsStyle="success" now={90} /></td>
              <td><span className="badge bg-green">90%</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  onNewUserClick(action,item='',e) {
    let {titleUser,inputUser} = this.state
    if (action==='create') {
      titleUser = "New User"
      inputUser = []
      inputUser['role'] = 'admin'
    } else {
      titleUser = "Edit User"
      inputUser['userid'] = item.userid
      inputUser['name'] = item.name
      inputUser['usertype'] = item.usertype
      inputUser['role'] = item.role
    }
    this.setState({showAddUser:true,titleUser:titleUser,inputUser:inputUser})
  }

  onRoleEditClick(item) {
    let {inputRole} = this.state
    inputRole['bf_role_id'] = item.bf_role_id
    inputRole['name'] = item.name
    this.setState({showAddRole:true,inputRole:inputRole})
  }

  onSaveNewUserClick(e) {
    let {titleSuccess} = this.state
    titleSuccess = "Update e-mail : test2 result : OK!"
    this.setState({showAddUser:false,showSuccess:true,titleSuccess:titleSuccess})
  }

  onSaveNewRoleClick() {
    let {inputRole} = this.state
    let postData = {name:inputRole['name']}
    AdminStore.saveRole(inputRole['bf_role_id'],postData,(result)=>{
      this.setState({showAddRole:false})
      if (result.status==='OK') {
        this.setState({showSuccess:true,titleSuccess:'Update role : '+postData.name+' result : OK!'})
      }
    },()=>{
      this.setState({showAddRole:false})
    })
  }

  onDeactiveClick() {
    // let {showDeactive} = this.state
    this.setState({showDeactive:true})
  }

  onRoleDeleteClick(item) {
    let {inputRole} = this.state
    inputRole['bf_role_id'] = item.bf_role_id
    inputRole['name'] = item.name
    this.setState({showRoleDelete:true,inputRole:inputRole})
  }

  onDeactiveUserClick(e) {
    let {titleSuccess} = this.state
    titleSuccess = "Deactive e-mail : test2 result : OK!"
    this.setState({showDeactive:false,showSuccess:true,titleSuccess:titleSuccess})
  } 

  onRoleDeleteConfirmClick() {
    let {inputRole} = this.state
    let role_id = inputRole['bf_role_id']
    let name = inputRole['name']
    AdminStore.delRole(role_id,(result)=>{
      this.setState({showRoleDelete:false})
      if (result.status==='OK') {
        this.setState({inputRole:[],showSuccess:true,titleSuccess:'Delete role : '+name+' result : OK!'})
        this.loadData()
      }
    },()=>{
      this.setState({showRoleDelete:false})
    })
  }

  onResetClick() {
    // let {showReset,inputPass} = this.state
    this.setState({showReset:true,inputPass:[]})
  }

  onResetPassClick(e) {
    let {titleSuccess,checkReset,inputPass} = this.state
    let _showReset = false
    let _showSuccess = false
    let _showPassNotMatch = false
    titleSuccess = "Update password : test2 result : OK!"
    if (checkReset<=0) {
      checkReset = 1
      _showReset = true
      _showSuccess = false
    } else {
      checkReset = 0
      _showReset = false
      if (inputPass['pass']===inputPass['con_pass']) {
        _showSuccess = true
      } else {
        _showPassNotMatch = true
      }
    }
    this.setState({showReset:_showReset,showSuccess:_showSuccess,titleSuccess:titleSuccess,checkReset:checkReset,showPassNotMatch:_showPassNotMatch})
  } 

  onRoleChange(field,e) {
    let {inputRole} = this.state
    inputRole[field] = e.target.value
    this.setState({inputRole:inputRole})
  }

  renderModalNewUser() {
    let {showAddUser,titleUser,inputUser} = this.state
    let role = [{label:"admin",value:"admin"},{label:"hr",value:"hr"},{label:"manager",value:"manager"},{label:"user",value:"user"}]

    return(
        <Modal show={showAddUser} onHide={()=>{this.setState({showAddUser:false})}} aria-labelledby="contained-modal-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">{titleUser}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Email
                </Col>
                <Col sm={7}>
                  <FormControl 
                    value={inputUser.userid}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Name
                </Col>
                <Col sm={7}>
                  <FormControl 
                    value={inputUser.name}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Type
                </Col>
                <Col sm={7}>
                  <FormControl 
                    value={inputUser.usertype}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Role
                </Col>
                <Col sm={4}>
                  <Select
                    clearable={false}
                    value={inputUser.role}
                    options={role}
                  />
                </Col>
              </FormGroup>
            </Form>  
          </Modal.Body>
          <Modal.Footer>
            <Button 
              className="btn btn-primary" 
              onClick={this.onSaveNewUserClick.bind(this)}
            >
              <FontAwsome name="save" />&nbsp;Save
            </Button>
            <Button onClick={()=>{this.setState({showAddUser:false})}}><FontAwsome name="remove" />&nbsp;Cancel</Button>
          </Modal.Footer>
        </Modal>
    )
  }
  
  renderModalNewRole() {
    let {showAddRole,inputRole} = this.state
    return(
        <Modal show={showAddRole} onHide={()=>{this.setState({showAddRole:false})}} aria-labelledby="contained-modal-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Edit Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Name
                </Col>
                <Col sm={7}>
                  <FormControl 
                    value={inputRole.name}
                    onChange={this.onRoleChange.bind(this,'name')}
                  />
                </Col>
              </FormGroup>
            </Form>  
          </Modal.Body>
          <Modal.Footer>
            <Button 
              className="btn btn-primary" 
              onClick={this.onSaveNewRoleClick.bind(this)}
            >
              <FontAwsome name="save" />&nbsp;Save
            </Button>
            <Button onClick={()=>{this.setState({showAddRole:false})}}><FontAwsome name="remove" />&nbsp;Cancel</Button>
          </Modal.Footer>
        </Modal>
    )
  }

  renderModalDeactive() {
    let {showDeactive} = this.state
    return(
        <Modal show={showDeactive} onHide={()=>{this.setState({showDeactive:false})}} aria-labelledby="contained-modal-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Deactive e-mail : test2 ?</Modal.Title>
          </Modal.Header>
          <Modal.Footer style={{borderTop:"none"}}>
            <Button className="btn btn-primary" onClick={this.onDeactiveUserClick.bind(this)}><FontAwsome name="thumbs-up" />&nbsp;Confirm</Button>
            <Button onClick={()=>{this.setState({showDeactive:false})}}><FontAwsome name="remove" />&nbsp;Cancel</Button>
          </Modal.Footer>
        </Modal>
    )
  }

  renderModalRoleDelete() {
    let {showRoleDelete,inputRole} = this.state
    return(
        <Modal show={showRoleDelete} onHide={()=>{this.setState({showRoleDelete:false})}} aria-labelledby="contained-modal-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Delete role : {inputRole.name} ?</Modal.Title>
          </Modal.Header>
          <Modal.Footer style={{borderTop:"none"}}>
            <Button className="btn btn-primary" onClick={this.onRoleDeleteConfirmClick.bind(this)}><FontAwsome name="thumbs-up" />&nbsp;Confirm</Button>
            <Button onClick={()=>{this.setState({showRoleDelete:false})}}><FontAwsome name="remove" />&nbsp;Cancel</Button>
          </Modal.Footer>
        </Modal>
    )
  }

  onResetPassChange(index,e) {
    let {inputPass} = this.state
    inputPass[index] = e.target.value
    this.setState({inputPass:inputPass})
  }

  renderModalResetPass() {
    let {showReset,checkReset,inputPass} = this.state
    let displayPass = ""
    let displayConPass = "none"
    if (checkReset===1) {
      displayPass = "none"
      displayConPass = ""
    }
    return(
        <Modal show={showReset} onHide={()=>{this.setState({showReset:false})}} aria-labelledby="contained-modal-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Reset password for e-mail : test2</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <FormGroup style={{display:displayPass}}>
                <Col componentClass={ControlLabel} sm={4}>
                  Password
                </Col>
                <Col sm={7}>
                  <FormControl 
                    type="password"
                    value={inputPass.pass}
                    onChange={this.onResetPassChange.bind(this,'pass')}
                  />
                </Col>
              </FormGroup>
              <FormGroup style={{display:displayConPass}}>
                <Col componentClass={ControlLabel} sm={4}>
                  Confirm password
                </Col>
                <Col sm={7}>
                  <FormControl 
                    type="password"
                    value={inputPass.con_pass}
                    onChange={this.onResetPassChange.bind(this,'con_pass')}
                  />
                </Col>
              </FormGroup>
            </Form>  
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-primary" onClick={this.onResetPassClick.bind(this)}><FontAwsome name="save" />&nbsp;Save</Button>
            <Button onClick={()=>{this.setState({showReset:false,checkReset:0})}}><FontAwsome name="remove" />&nbsp;Cancel</Button>
          </Modal.Footer>
        </Modal>
    )
  }

  renderManageUser() {
    return(
              <Box loading={false}>
                <Box.Header border={true}>
                  Manage User
                </Box.Header>    
                <Box.Body>
                  {this.renderUserTable()}
                </Box.Body>  
                <Box.Footer>
                  <div className="pull-right">
                    <Button className="btn btn-success" onClick={this.onNewUserClick.bind(this,'create')}><FontAwsome name="plus" />&nbsp;New User</Button>
                  </div>
                </Box.Footer>        
              </Box>
    )
  }

  renderManageRole() {
    return(
      <Box loading={false}>
        <Box.Header border={true}>
          Manage Role
        </Box.Header>    
        <Box.Body>
          {this.renderRoleTable()}
        </Box.Body>       
      </Box>
    ) 
  }

  renderAaccountSetting() {
    return(
      <div>
        {this.renderManageUser()}
        {this.renderManageRole()}
      </div>
    )
  }

  render() {
    let {showSuccess,titleSuccess,showPassNotMatch} = this.state
    let {mode} = this.props
    return(
      <div>
        {mode==='account-setting'?
        this.renderAaccountSetting()
        :
        <div>
          <Row>
            <Col md={9}>
              {this.renderManageUser()}
            </Col>
            <Col md={3}>
              <Box loading={false}>
                <Box.Header border={true}>
                  Work/Invoice Options
                </Box.Header>    
                <Box.Body>
                  {this.renderOption()}
                </Box.Body>  
                <Box.Footer>
                  <div className="pull-right">
                    <Button className="btn btn-primary"><FontAwsome name="save" />&nbsp;Save</Button>
                  </div>
                </Box.Footer>        
              </Box>
              <Button
                className="btn btn-danger"
              >  
                <FontAwsome name="warning" />&nbsp;Reset App Site
              </Button>
            </Col>
          </Row>  
          <Row>
            <Col md={9}>
              {this.renderManageRole()}
            </Col>
          </Row>
          <Row>
            <Col md={9}>
              <Box loading={false}>
                <Box.Header border={true}>
                  Activity Log
                </Box.Header>    
                <Box.Body className="no-padding">
                  {this.renderActivityLog()}
                </Box.Body>       
              </Box>
            </Col>
          </Row>
        </div>}
        {this.renderModalNewUser()}
        {this.renderModalNewRole()}
        {this.renderModalDeactive()}  
        {this.renderModalRoleDelete()}
        {this.renderModalResetPass()}    

        <Modal show={showSuccess} onHide={()=>{this.setState({showSuccess:false})}} aria-labelledby="contained-modal-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">{titleSuccess}</Modal.Title>
          </Modal.Header>
          <Modal.Footer style={{borderTop:"none"}}>
            <Button className="btn" onClick={()=>{this.setState({showSuccess:false})}}><FontAwsome name="remove" />&nbsp;Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showPassNotMatch} onHide={()=>{this.setState({showPassNotMatch:false})}} aria-labelledby="contained-modal-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Password and confirm password do not match!</Modal.Title>
          </Modal.Header>
          <Modal.Footer style={{borderTop:"none"}}>
            <Button className="btn" onClick={()=>{this.setState({showPassNotMatch:false})}}><FontAwsome name="remove" />&nbsp;Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

AdminPage.defaultProps = {
  mode:'all'
}

export default AdminPage;  


// WEBPACK FOOTER //
// ./src/view/admin/AdminPage.js